import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import ko from './ko.json';

const saved = typeof localStorage !== 'undefined' ? localStorage.getItem('locale') : null;
void i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, ko: { translation: ko } },
  lng: saved ?? (navigator.language.startsWith('ko') ? 'ko' : 'en'),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});
export function setLocale(lng: 'en' | 'ko') {
  localStorage.setItem('locale', lng);
  void i18n.changeLanguage(lng);
}
export default i18n;
